<template>
    <hts-tooltip>
        <template #reference>
            <hts-icons
                svg="location-dark"
                class-name="h-12 w-12 cursor-pointer transition-all hover:text-gray-500"
                :class="{
                    '!fill-gray-700': showLocation,
                    '!fill-gray-300': !showLocation
                }"
                @click="change" />
        </template>
        <span>
            {{ label }}
        </span>
    </hts-tooltip>
</template>
<script setup lang="ts">
const props = defineProps({
  label: {
    type: String,
    default: 'Ẩn/hiện địa điểm hệ thống trên bản đồ'
  },
  storeKey: {
    type: String,
    default: 'system'
  }
})

const { map } = $store()

const { storeKey } = toRefs(props)

const showLocation = computed(() => {
  if (!map) {
    return
  }

  return map.getShowLocation[storeKey.value]
})

const change = () => {
  if (!map) {
    return
  }

  map.setShowLocation({ [storeKey.value]: !showLocation.value })
}
</script>
